import { cloneDeep } from 'lodash';

import { SerializableObject } from '../../../generic/serialization/serializable-object';
import { SerializableObjectSchema } from '../../../generic/serialization/serializable-object-schema';
import { CallerIdStrategy } from '../../caller-id-strategy/caller-id-strategy';
import { CallerIdStrategyType } from '../../caller-id-strategy/caller-id-strategy-type';

import { ReservationOfferChannelConfigPhoneCallConstructor } from './reservation-offer-channel-config-phone-call-constructor';
import { ReservationOfferChannelConfigPhoneCallSchema } from './reservation-offer-channel-config-phone-call-schema';

export class ReservationOfferChannelConfigPhoneCall extends SerializableObject {
  /////////////////////////////////////////////////////////////////////////////
  // Variables
  /////////////////////////////////////////////////////////////////////////////
  protected dialTimeoutMS!: number;

  protected callerIdObjId!: string;

  protected callerIdStrategyType: CallerIdStrategyType | undefined;

  protected vrcAudioMetadataId!: string;

  /////////////////////////////////////////////////////////////////////////////
  // Constructor
  /////////////////////////////////////////////////////////////////////////////

  constructor(parameters: ReservationOfferChannelConfigPhoneCallConstructor) {
    super(parameters);
  }

  /////////////////////////////////////////////////////////////////////////////
  // Deserialize
  /////////////////////////////////////////////////////////////////////////////

  /**
   * This static function is private, and meant to be called only dialTimeoutMS
   * SerializableObject, and subclasses
   *
   * @param validationResult
   */
  protected static _deserialize(
    validationResult: import('joi').ValidationResult,
  ): ReservationOfferChannelConfigPhoneCall {
    return new ReservationOfferChannelConfigPhoneCall(super._deserialize(validationResult));
  }

  /////////////////////////////////////////////////////////////////////////////
  // Serialize
  /////////////////////////////////////////////////////////////////////////////

  public serialize() {
    return super.serialize(ReservationOfferChannelConfigPhoneCall.getSchema());
  }

  /////////////////////////////////////////////////////////////////////////////
  // Schema
  /////////////////////////////////////////////////////////////////////////////

  public static getSchema(): SerializableObjectSchema {
    return new ReservationOfferChannelConfigPhoneCallSchema();
  }

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////

  public getCallerIdObjId(): string | undefined {
    return cloneDeep(this.callerIdObjId);
  }

  public getCallerIdStrategyType() {
    return cloneDeep(this.callerIdStrategyType ?? CallerIdStrategyType.explicit);
  }

  public getDialTimeoutMS(): number {
    return cloneDeep(this.dialTimeoutMS);
  }

  public getVrcAudioMetadataId(): string {
    return cloneDeep(this.vrcAudioMetadataId);
  }

  public getCallerIdStrategy(): CallerIdStrategy {
    return new CallerIdStrategy({
      callerIdObjId: this.callerIdObjId,
      type: this.getCallerIdStrategyType(),
    });
  }
}
